import { t } from '@/locales';

export function getWeekdayLabels(): string[] {
  return [
    t('datePicker.weekdayMon'),
    t('datePicker.weekdayTue'),
    t('datePicker.weekdayWed'),
    t('datePicker.weekdayThu'),
    t('datePicker.weekdayFri'),
    t('datePicker.weekdaySat'),
    t('datePicker.weekdaySun'),
  ];
}

export function getMonthNames(): string[] {
  return [
    t('datePicker.monthJan'),
    t('datePicker.monthFeb'),
    t('datePicker.monthMar'),
    t('datePicker.monthApr'),
    t('datePicker.monthMay'),
    t('datePicker.monthJun'),
    t('datePicker.monthJul'),
    t('datePicker.monthAug'),
    t('datePicker.monthSep'),
    t('datePicker.monthOct'),
    t('datePicker.monthNov'),
    t('datePicker.monthDec'),
  ];
}

export function getWeekdayFull(): string[] {
  return [
    t('datePicker.weekdayFullSun'),
    t('datePicker.weekdayFullMon'),
    t('datePicker.weekdayFullTue'),
    t('datePicker.weekdayFullWed'),
    t('datePicker.weekdayFullThu'),
    t('datePicker.weekdayFullFri'),
    t('datePicker.weekdayFullSat'),
  ];
}

// Keep static versions for backward compatibility (used during SSR/build)
export const WEEKDAY_LABELS = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];

export const MONTH_NAMES = [
  'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre',
];

export function toLocalDateStr(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function buildCalendarDays(year: number, month: number) {
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  let startWeekday = firstDay.getDay() - 1; // Monday-based
  if (startWeekday < 0) startWeekday = 6;

  const days: { date: string; day: number; isCurrentMonth: boolean }[] = [];

  // Previous month padding
  const prevMonthLast = new Date(year, month, 0);
  for (let i = startWeekday - 1; i >= 0; i--) {
    days.push({
      date: toLocalDateStr(new Date(year, month - 1, prevMonthLast.getDate() - i)),
      day: prevMonthLast.getDate() - i,
      isCurrentMonth: false,
    });
  }

  // Current month
  for (let d = 1; d <= lastDay.getDate(); d++) {
    days.push({
      date: toLocalDateStr(new Date(year, month, d)),
      day: d,
      isCurrentMonth: true,
    });
  }

  // Next month padding
  const remaining = 7 - (days.length % 7);
  if (remaining < 7) {
    for (let d = 1; d <= remaining; d++) {
      days.push({
        date: toLocalDateStr(new Date(year, month + 1, d)),
        day: d,
        isCurrentMonth: false,
      });
    }
  }

  return days;
}
